import { ActionDetailsActions } from "./ActionDetails-slice";
import axios from 'axios'
// import '../utils/axios-interceptor'

export const fetchPageData = (url_data, token) => {
	return async (dispatch) => {
		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const pageData = await fetchData();
			dispatch(ActionDetailsActions.updatePageData(pageData));
		} catch (error) {
			console.log(error);
		}
	};
};
